$(document).ready(function() {
  $(document).on('click', '.gv-mmy-bar .gv-btn-search', function() {
    // Check if the button is not disabled
    if (!$(this).prop("disabled")) {
      // Change the value to "Loading..." when clicked
      $(this).val("Loading...").css("background-color", "#589142");;
    }
  });
});